import { UNPROCESSABLE_ENTITY } from '@mm/constants/status-codes';
import { Dispatch } from 'redux';
import { StoreState } from '../store-interfaces';
import { ResponseOrError } from './common-handler';
import { getErrorJson } from '@mm/utils';
import modalActions from '../modules/modalsState/actions';
import { unbusyAll } from '../actions/commonActions';

export const sendlaneErrorHandler =
  (dispatch: Dispatch<StoreState>) => async (error: ResponseOrError) => {
    if (error instanceof Response && error.status === UNPROCESSABLE_ENTITY) {
      const parsed = await getErrorJson(error);
      dispatch(
        modalActions.openPrettyErrorModal({
          errorMessage: parsed.message,
          title: 'Failed',
        }),
      );
      dispatch(unbusyAll());
    } else {
      throw error;
    }
  };
